const { onsiteLabels, validDrugLabels } = require('@/api/fullyused')

export default {
  'entityName': 'fullyused_has_drug',
  'title': 'Fully used drug',
  id: ['fullyused_id', 'drug_id', 'lotto', 'label'],
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'sortBy': 'drug_id',
    'descending': true
  },
  'fields': [
    {
      'value': 'drug_id',
      'text': 'Label',
      // reference: 'siteresponse_has_drug',
      list: (entity, search, item) => onsiteLabels(search, item.protocol_id, item.site_id),
      'type': 'autocomplete',
      title: 'drug.name',
      id: 'drug.id',
      subtitle: ({ drug }) => drug.packaging !== 'Labels' ? `${drug.name} (${drug.packaging}, ${drug.dose}${drug.measure_unit})` : `${drug.name} (${drug.packaging} - ${drug.labels?.join(',')}) `,
      table: true,
      render: ({drug}) => drug.packaging !== 'Labels' ? `${drug.name} (${drug.packaging}, ${drug.dose}${drug.measure_unit})` : `${drug.name} (${drug.packaging} - ${drug.labels?.join(',')}) `,
      validators: ['required'],
    },
    {
      value: 'label',
      text: 'Label applied to',
      title: 'label',
      id: 'label',
      table: true,
      readonly: item => !(item.n_pieces>0),
      deps: ['drug_id'],
      list: (entity, search, item) => validDrugLabels(item.drug_id),
      type: 'autocomplete',
      validators: ['required'],
    },
    {
      value: '_n_available_pieces',
      deps: ['drug_id'],
      type: 'hidden',
      default: (item, args, selected) => selected && selected.n_pieces
    },    
    {
      'value': 'n_pieces',
      'text': 'N. used',
      'type': 'number',
      'table': {
        'sortable': true,
        'filter': false
      },
      small: true,
      deps: ['n_lost'],
      readonly: item => !item.drug_id || item.n_lost>0,
      'validators': [
          (field, value, item) => ((item.n_pieces||0) + (item.n_lost||0) + (item.n_destroyed||0) ) > 0 || `Should fill something`,
          (field, value, item) => ((item.n_pieces||0) + (item.n_lost||0) + (item.n_destroyed||0) <= (item._n_available_pieces||0)) || `Should be <= of available pieces (${(item.n_pieces||0)+(item.n_lost||0)+(item.n_destroyed||0)} > ${item._n_available_pieces||0})`,
      ]
    },
    {
      'value': 'n_lost',
      'text': 'N. lost',
      'type': 'number',
      'table': {
        'sortable': true,
        'filter': false
      },
      small: true,
      deps: ['n_pieces'],
      readonly: item => !item.drug_id || item.n_pieces>0 || item.n_destroyed>0,
      validators: [
        (field, value, item) => ((item.n_pieces||0) + (item.n_lost||0) + (item.n_destroyed||0) ) > 0 || `Should fill something`,
        (field, value, item) => ((item.n_pieces||0) + (item.n_lost||0) + (item.n_destroyed||0) <= (item._n_available_pieces||0)) || `Should be <= of available pieces (${(item.n_pieces||0)+(item.n_lost||0)+(item.n_destroyed||0)} > ${item._n_available_pieces||0})`,
      ]
    },
    {
      'value': 'n_destroyed',
      'text': 'N. destroyed',
      'type': 'number',
      small: true,
      deps: ['n_lost'],
      'table': {
        'sortable': true,
        'filter': false
      },
      readonly: item => !item.drug_id || item.n_lost>0,
      validators: [
        (field, value, item) => ((item.n_pieces||0) + (item.n_lost||0) + (item.n_destroyed||0) ) > 0 || `Should fill something`,
        (field, value, item) => ((item.n_pieces||0) + (item.n_lost||0) + (item.n_destroyed||0) <= (item._n_available_pieces||0)) || `Should be <= of available pieces (${(item.n_pieces||0)+(item.n_lost||0)+(item.n_destroyed||0)} > ${item._n_available_pieces||0})`,
      ]
    },    
  ],
  actions: ['remove']
}
